module.exports = __webpack_public_path__ + "static/media/document-text.04b6c76c.svg";